import { PrivilegeChecker } from 'omni-common-ui';
import { routes as assignments } from './Assignments';
import { routes as unlockHomework } from './UnlockHomework';
import AssignHomework from './component';
import Privileges from 'domain/Privileges';
import TabSwitcher, { TabCodes } from 'domain/TabSwitcher';
import * as Session from 'data/SessionPlans/accessors';
import { isUnlockHomeworkEnabled } from './UnlockHomework/routes';
import { actions as groupActions } from 'containers/Group';

const getSecondLevelTabs = (getState, { location: { pathname }, buildRoute, push, params }) => {
  const defaultSession = Session.getDefaultSession(getState(), params.groupId);
  const sessionPlanId = defaultSession && defaultSession.id;
  const assignmentsparams = {
    ...params,
    sessionPlanId,
    unitId: Session.getFirstUnitOfSession(getState(), sessionPlanId),
  };
  if (isUnlockHomeworkEnabled(getState(), params.groupId) &&
    ! groupActions.hasContentPath(getState(), params.groupId)) {
    return [{
      text: 'Assignments',
      onClick: () => push(buildRoute('/group/:groupId/assign-homework/session/:sessionPlanId(/unit/:unitId)', assignmentsparams)),
      isActive: pathname.includes('assign-homework/session'),
    },
    {
      text: 'Unlock Practice',
      onClick: () => push(buildRoute('/group/:groupId/assign-homework/unlock-homework', params)),
      isActive: pathname.includes('unlock-homework'),
    }];
  }
};

export default ({ getState }) => ({
  path: 'assign-homework',
  component: AssignHomework,
  canAccess: ({ params }) =>
    PrivilegeChecker.hasPrivilege(getState(), Privileges.AssignHomework.View) &&
        TabSwitcher.isTabEnabled(getState(), params.groupId, TabCodes.AssignHomework),
  breadcrumbLabels: () => ({
    label: 'At Home Review',
    clickable: false,
  }),
  tab: {
    label: 'At Home Review',
    order: 4,
    isVisible: (params) =>
      PrivilegeChecker.hasPrivilege(getState(), Privileges.AssignHomework.View) &&
          TabSwitcher.isTabEnabled(getState(), params.groupId, TabCodes.AssignHomework),
  },
  secondLevelTabs: (props) =>
    getSecondLevelTabs(getState, props),
  childRoutes: [
    assignments,
    unlockHomework,
  ],
});




// WEBPACK FOOTER //
// ./containers/Group/AssignHomework/routes.js